import {
  Component,
  ElementRef,
  NgZone,
  OnInit,
  ViewEncapsulation,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { GroupService } from "../groups/groups.service";
import { FormValidator } from "../form.validator";
import { Offcanvas } from "../form.offcanvas";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../../config/config";
import { Router } from "@angular/router";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { LoginService } from "../login/login.service";
import { AdmissionService } from "../admission/admission.service";
import { TransportService } from "../transport/transport.service";
import { HeaderComponent } from "../header/header.component";
import { HeaderService } from "../header/header.service";
import { ScriptLoader } from "../script-loader";
import { commonFunctionService } from "../utils/commonFunctions";
import * as broadcastStrings from "../stringFiles/broadcast.strings.json";
import { BroadcastService } from "./broadcast-service.service";
import { firstValueFrom } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

declare var $: any; 
declare var customToastr: any; 

@Component({
  selector: "app-broadcast",
  templateUrl: "./broadcast.component.html",
  styleUrls: [
    "./../../assets/css/theme-default/bootstrap.css",
    "./../../assets/css/theme-default/materialadmin.css",
    "./../../assets/css/theme-default/font-awesome.min.css",
    "./../../assets/css/theme-default/material-design-iconic-font.min.css",
    "./../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css",
    "./../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/buttons.dataTables.min.css",
    "./../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css",
    "./../../_crop/css/style.css",
    "./../../_crop/css/style-example.css",
    "./broadcast.component.css",
  ],
  encapsulation: ViewEncapsulation.None,
  providers: [
    GroupService,
    FormValidator,
    LoginService,
    AdmissionService,
    Offcanvas,
    TransportService,
    HeaderComponent,
    HeaderService,
    ScriptLoader,
  ],
})
export class BroadcastComponent implements OnInit {
  strings: any;
  loginMode = "";
  schoolCategories = [];
  isPopupVisible = false;
  showOverlay = false;
  mediaPreviewPopup = false;
  createBroadcast: FormGroup;
  previewUrls: (string | null)[] = [];
  attachments: File[] = [];
  academicYears: Array<any> = [];
  broadcastReceivers: Array<any> = [];
  selectedYearId: number | null = null;
  selectedReceiverId: string = "";
  createButtonVisible: boolean = false;
  createBroadcastFormSubmit = false;
  isPageLoading = true;
  previewMediaList: Array<any> = [];
  isDragOver = false;

  broadcastData: any[] = [];
  totalRecords: number = 0;
  currentPage: number = 1;
  pageSize: number = 10;
  totalPages: number = 0;
  maxVisiblePages: number = 3;
  visiblePages: number[] = [];
  hasLeftEllipsis: boolean = false;
  hasRightEllipsis: boolean = false;
  @ViewChild("fileInput") fileInput!: ElementRef;

  constructor(
    private ngZone: NgZone,
    private groupservice: GroupService,
    private formValidator: FormValidator,
    private http: HttpClient,
    elementRef: ElementRef,
    renderer: Renderer2,
    private elRef: ElementRef,
    private offcanvas: Offcanvas,
    private transportservice: TransportService,
    private scriptLoader: ScriptLoader,
    private commonFunction: commonFunctionService,
    private router: Router,
    private loginservice: LoginService,
    public headerComponent: HeaderComponent,
    private fb: FormBuilder,
    private broadcastService: BroadcastService,
    private translate: TranslateService
  ) {
    this.strings = broadcastStrings;
    this.createBroadcast = this.fb.group({
      broadcastType: [{ value: "", disabled: false }, Validators.required],
      broadcastSubject: [
        { value: "", disabled: false },
        [Validators.required, Validators.minLength(2)],
      ],
      broadcastMessage: [
        { value: "", disabled: false },
        [Validators.required, Validators.minLength(3)],
      ],
      priority: [
        { value: false, disabled: false },
        [Validators.pattern("true|false")],
      ],
      attachment: [{ value: [], disabled: false }],
    });
  }

  calculatePages() {
    const pagesSet = new Set<number>(); 
    this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
    if (this.totalPages > this.maxVisiblePages) {
      pagesSet.add(1).add(2).add(3);

      if (this.currentPage > 5) {
        pagesSet.add(0);
      }
      const startPage = Math.max(4, this.currentPage - 1);  
      const endPage = Math.min(this.totalPages - 3, this.currentPage + 1);
      for (let i = startPage; i <= endPage; i++) {
        pagesSet.add(i); 
      }
      if (this.currentPage + 1 < this.totalPages - 3) {
        pagesSet.add(0);
      }
      pagesSet.add(this.totalPages - 2);
      pagesSet.add(this.totalPages - 1);
      pagesSet.add(this.totalPages);
    } 
    else {
      for (let i = 1; i <= this.totalPages; i++) {
        pagesSet.add(i); 
      }
    }
    const pages = Array.from(pagesSet);
    this.visiblePages = pages;
  }

  goToPage(page: number) {
    if (page !== this.currentPage) {
      this.currentPage = page;
      this.calculatePages();
      this.fetchBroadcastData();
    }
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.calculatePages();
      this.fetchBroadcastData();
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.calculatePages();
      this.fetchBroadcastData();
    }
  }

  async onFileChange(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    const files = input?.files ? Array.from(input.files) : [];

    if (!files.length) {
      return;
    }

    await this.processFiles(files);
    input.value = "";
  }

  removeAttachment(index: number): void {
    if (index < 0 || index >= this.attachments.length) {
      return;
    }
    this.attachments.splice(index, 1);
    this.previewUrls.splice(index, 1);
    this.createBroadcast.get("attachment")?.setValue([...this.attachments]);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.attachments.length < 5) {
      this.isDragOver = true;
    }
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  async onDrop(event: DragEvent): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    if (this.attachments.length >= 5) {
      const maxFilesErrorTranslation = await firstValueFrom(
        this.translate.get("maxFileUpload")
      );
      customToastr(maxFilesErrorTranslation, "error");
      return;
    }

    const files = event.dataTransfer?.files;
    if (!files || files.length === 0) {
      return;
    }

    const fileArray = Array.from(files);
    await this.processFiles(fileArray);
  }

  async openAttachmentPicker(): Promise<void> {
    if (this.attachments.length >= 5) {
      const maxFilesErrorTranslation = await firstValueFrom(
        this.translate.get("maxFileUpload")
      );
      customToastr(maxFilesErrorTranslation, "error");
      return;
    }
    this.fileInput.nativeElement.click();
  }

  private async processFiles(files: File[]): Promise<void> {
    const newTotal = this.attachments.length + files.length;
    if (newTotal > 5) {
      const maxFilesErrorTranslation = await firstValueFrom(
        this.translate.get("maxFileUpload")
      );
      customToastr(maxFilesErrorTranslation, "error");
      return;
    }

    const allowedTypes = [
      "image/png",
      "image/jpg",
      "image/jpeg",
      "image/webp",
      "application/pdf",
    ];
    const maxSize = 25 * 1024 * 1024;

    for (const file of files) {
      if (!allowedTypes.includes(file.type)) {
        const formatError = await firstValueFrom(
          this.translate.get("attachementFormatValidation")
        );
        customToastr(formatError, "error");
        return;
      }
      if (file.size > maxSize) {
        const sizeError = await firstValueFrom(
          this.translate.get("attachementSizeValidation")
        );
        customToastr(sizeError, "error");
        return;
      }
    }

    files.forEach((file) => {
      const insertIndex = this.attachments.length;
      this.attachments.push(file);
      this.previewUrls.splice(insertIndex, 0, null);

      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = () => {
          this.previewUrls[insertIndex] = reader.result as string;
        };
        reader.readAsDataURL(file);
      }
    });

    this.createBroadcast.get("attachment")?.setValue([...this.attachments]);
  }

  
  private resetFileInput() {
    this.fileInput.nativeElement.value = "";
  }

  onBlur(controlName: string): void {
    const control = this.createBroadcast.get(controlName);
    if (control) {
      const trimmedValue = control.value.trim();
      control.setValue(trimmedValue, { emitEvent: false });
      control.markAsTouched();
      control.updateValueAndValidity();
      if (trimmedValue === "") {
        control.setErrors({ required: true });
      } else {
        if (control.errors && control.errors.required) {
          control.setErrors({ ...control.errors, required: null });
        }
      }
    }
  }

  disableFormControls() {
    Object.keys(this.createBroadcast.controls).forEach((controlName) => {
      this.createBroadcast.get(controlName)?.disable();
    });
  }

  enableFormControls() {
    Object.keys(this.createBroadcast.controls).forEach((controlName) => {
      this.createBroadcast.get(controlName)?.enable();
    });
  }

  getAuthToken = localStorage.getItem("usertoken");
  getSchoolId = localStorage.getItem("schoolinfo");
  permissions: any = {
    SCHOOL_STUDENT_MANAGEMENT: "",
    SCHOOL_STAFFS_MANAGEMENT: "",
  };

  isValidToken() {
    let isValidToken = false;
    let isValidSchool = 0;
    this.loginservice.isValidToken(localStorage.getItem("usertoken")).subscribe(
      (data: any) => {
        isValidToken = data.isValid;
        if (data.errorcode === 10010) {
          this.router.navigate(["/suspended"]);
        } else if (isValidToken === true) {
          this.loginservice
            .isValidSchoolId(localStorage.getItem("schoolinfo"))
            .subscribe(
              (isValidData: any) => {
                isValidSchool = isValidData.schoolExist;
                this.getSchoolId = localStorage.getItem("schoolinfo");
                if (isValidSchool !== 1) {
                  this.router.navigate(["/login"]);
                } else if (this.loginMode === "STAFF") {
                  this.router.navigate(["/exams"]);
                }
              },
              (error) => {}
            );
        } else {
          this.router.navigate(["/login"]);
        }
      },
      (error) => {}
    );
  }

  ngOnInit() {
    this.getAcademicYear();
    this.getBroadcastType();
    this.calculatePages();
    let state = window.history.state;
    this.loginMode = localStorage.getItem("loginMode");
    const adminPermissionlist = localStorage.getItem("adminPermissionlist");
    if (adminPermissionlist) {
      const list = JSON.parse(adminPermissionlist);
      this.permissions = list;
      if (this.permissions.SCHOOL_STUDENT_MANAGEMENT === "ENABLED") {
        $("#first1").addClass("active");
        $("#second1").removeClass("active");
        $("#student_tab").trigger("click");
        if (
          state &&
          state.tab === "staffs" &&
          this.permissions.SCHOOL_STAFFS_MANAGEMENT === "ENABLED"
        ) {
          $("#first1").removeClass("active");
          $("#second1").addClass("active");
          $("#staff_tab").trigger("click");
        }
      } else if (this.permissions.SCHOOL_STAFFS_MANAGEMENT === "ENABLED") {
        $("#first1").removeClass("active");
        $("#second1").addClass("active");
        $("#staff_tab").trigger("click");
      }
    }
    this.isValidToken();
  }

  openPopup() {
    this.showOverlay = true;
    setTimeout(() => {
      this.isPopupVisible = true;
    }, 100);
  }

  closePopup() {
    this.isPopupVisible = false;
    this.createBroadcast.reset({
      broadcastType: "",
      broadcastSubject: "",
      broadcastMessage: "",
      priority: false,
      attachment: [],
    });
    this.createBroadcast.get("attachment")?.setValue([]);
    this.previewUrls = [];
    this.attachments = [];
    setTimeout(() => {
      if (!this.mediaPreviewPopup) {
        this.showOverlay = false;
      }
    }, 500);
  }

  openMediaPreviewPopup(mediaList: Array<any>) {
    if (!mediaList || mediaList.length === 0) {
      return;
    }
    this.previewMediaList = mediaList;
    this.showOverlay = true;
    this.mediaPreviewPopup = true;
  }

  closeMediaPreviewPopup() {
    this.mediaPreviewPopup = false;
    this.previewMediaList = [];
    if (!this.isPopupVisible) {
      this.showOverlay = false;
    }
  }

  openMedia(mediaUrl: string | null) {
    if (mediaUrl) {
      window.open(mediaUrl, "_blank");
    }
  }

  isImageMedia(mediaType: string): boolean {
    return mediaType?.toUpperCase() === "IMAGE";
  }

  getMediaLabel(media: any, index: number): string {
    const label = this.isImageMedia(media.broadcastMediaType) ? "Image" : "Document";
    return `${label} ${index + 1}`;
  }

  async onSubmit() {
    try {
      if (this.createBroadcast.valid) {
        this.createBroadcastFormSubmit = true;
        this.disableFormControls();
        const body = {
          lang: "en",
          academicId: this.selectedYearId.toString(),
          broadcastReceiverId: this.createBroadcast
            .get("broadcastType")
            ?.value.toString(),
          isHighPriority: this.createBroadcast
            .get("priority")
            ?.value.toString(),
          broadcastMessage: this.createBroadcast.get("broadcastMessage")?.value,
          broadcastSubject: this.createBroadcast.get("broadcastSubject")?.value,
        };
        const media = this.createBroadcast.get("attachment")?.value;
        const response: any = await firstValueFrom(
          this.broadcastService.createBroadcastService(body, media)
        );
        this.createBroadcastFormSubmit = false;
        this.enableFormControls();
        if (response?.status) {
         const createBroadcastSuccessMessageTranslation = await firstValueFrom(this.translate.get('createBroadcastSuccessMessage')); 
         customToastr(createBroadcastSuccessMessageTranslation, 'success');
          this.fetchBroadcastData();
          this.closePopup();
        } else {
          this.createBroadcastFormSubmit = false;
          const BroadcastFailedToCreateErrorTextTranslation = await firstValueFrom(this.translate.get('BroadcastFailedToCreateErrorText')); 
          customToastr(BroadcastFailedToCreateErrorTextTranslation, 'error');
        }
      } else {
        this.createBroadcastFormSubmit = false;
        const pleaseFillDetailsErrorMessageTranslation = await firstValueFrom(this.translate.get('pleaseFillDetailsErrorMessage')); 
        customToastr(pleaseFillDetailsErrorMessageTranslation, 'error');
      }
    } catch (error) {
      this.createBroadcastFormSubmit = false;
      const BroadcastFailedToCreateErrorTextTranslation = await firstValueFrom(this.translate.get('BroadcastFailedToCreateErrorText')); 
      customToastr(BroadcastFailedToCreateErrorTextTranslation, 'error');
    }
  }

  async getAcademicYear() {
    try {
      const response: any = await firstValueFrom(
        this.broadcastService.getAcademicYears()
      );
      if (response?.status) {
        if (response?.body?.currentAndPastAcademicData) {
          this.academicYears = response.body.currentAndPastAcademicData;
        }
        const currentAcademic = this.academicYears.find(
          (year) => year.isCurrentAcademic
        );
        if (currentAcademic) {
          this.selectedYearId = currentAcademic.pkAcademicId;
          this.createButtonVisible = true;
          this.fetchBroadcastData();
        } else {
          this.createButtonVisible = false;
        }
      }
      else {
       const pleaseTryAfterSomeTimeErrorMessageTranslation = await firstValueFrom(this.translate.get('pleaseTryAfterSomeTimeErrorMessage')); 
       customToastr(pleaseTryAfterSomeTimeErrorMessageTranslation, 'error');
      }
    } 
    catch (error) {
      const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong')); 
      customToastr(somethingWentWrongTranslation, 'error');
    }
  }

  onSelectionChange(): void {
    if (this.selectedYearId) {
      const selectedYear = this.academicYears.find(
        (year) => year.pkAcademicId === +this.selectedYearId
      );
      this.createButtonVisible = selectedYear?.isCurrentAcademic ?? false;
      this.fetchBroadcastData();
    }
  }
  removeFilter():void {
    this.selectedReceiverId = "";
    this.fetchBroadcastData();
  }

  async getBroadcastType() {
    try {
      const response: any = await firstValueFrom(
        this.broadcastService.getBroadcastType()
      );
      if (response?.status) {
        if (response?.body?.broadcastReceiverData) {
          this.broadcastReceivers = response?.body?.broadcastReceiverData;
          this.fetchBroadcastData();
        }
      } else {
        const pleaseTryAfterSomeTimeErrorMessageTranslation = await firstValueFrom(this.translate.get('pleaseTryAfterSomeTimeErrorMessage')); 
        customToastr(pleaseTryAfterSomeTimeErrorMessageTranslation, 'error');
      }
    } 
    catch (error) {
      const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong')); 
      customToastr(somethingWentWrongTranslation, 'error');
    }
  }

  async fetchBroadcastData() {
    try {
      this.isPageLoading = true;
      if (this.selectedYearId) {
        const response: any = await firstValueFrom(
          this.broadcastService.getBroadcast(
            this.selectedYearId,
            this.selectedReceiverId,
            this.currentPage,
            this.pageSize
          )
        );
        if (response?.status) {
          this.totalRecords = response.body.maxPageNumber * this.pageSize;
          this.broadcastData = response.body.broadcastDetail || [];
          this.calculatePages();
        }
        else {
          const pleaseTryAfterSomeTimeErrorMessageTranslation = await firstValueFrom(this.translate.get('pleaseTryAfterSomeTimeErrorMessage')); 
          customToastr(pleaseTryAfterSomeTimeErrorMessageTranslation, 'error');
        }
        this.isPageLoading = false;
      }
    } 
    catch (error) {
      this.isPageLoading = false;
      const somethingWentWrongTranslation = await firstValueFrom(this.translate.get('somethingWentWrong')); 
      customToastr(somethingWentWrongTranslation, 'error');
    }
  }

  getSerialNumber(index: number): number {
    return (this.currentPage - 1) * this.pageSize + index + 1;
  }

}
